module.exports = __webpack_public_path__ + "static/media/base.5302c132.png";